import styled from 'styled-components/macro';

import Table from 'components/data-visualization/Table/Table';
import Row from 'components/data-visualization/Table/Row';
import Cell from 'components/data-visualization/Table/Cell';
import Layout from 'components/styled/Layout/Layout';
import { Toolbar } from 'components/utility/GenericComponent/GenericComponent';
import { ComponentTitle } from 'styles/global/typography/typography';
import { definitionLabel } from 'styles/base-classes';

export const ConcertsTable = styled(Table)`
  border-collapse: collapse;

  thead span {
    color: #8ea6be;
  }
`;

export const ConcertRow = styled(Row)`
  border-bottom: 1px solid ${({ theme }): string => theme.Grey};
`;

export const ConcertCell = styled(Cell)`
  min-width: 110px;
  padding-top: 1.25em;
  padding-bottom: 1.25em;

  &.date {
    font-weight: 600;
  }
`;

export const List = styled.ol`
  display: flex;
  flex-flow: column nowrap;
  height: 620px;
  overflow-y: auto;
  padding: 0;
  margin: 0;
  color: ${({ theme }): string => theme.DeepBlue};
`;

export const ListItem = styled('li')`
  display: flex;
  flex-direction: column;
  padding: 1.25em 0.625em 1.875em 0;
  border-bottom: 1px solid ${({ theme }): string => theme.Grey};

  &:hover {
    background: ${({ theme }): string => theme.Sand};
  }
`;

export const Label = styled('span')`
  ${definitionLabel};
  min-width: 80px;
  font-size: 0.625em;
  padding-bottom: 6px;
  cursor: pointer;
`;

export const Item = styled('div')`
  display: flex;
  align-items: baseline;
  padding: 0.4em 0;

  &:first-of-type {
    p {
      font-weight: 600;
    }
  }
`;

export const GenericComponentWrapper = styled('div')`
  @media screen and (max-width: 60em) {
    ${ComponentTitle} {
      font-size: 1.5em;
    }
    ${Layout.MaxWidth} {
      margin: 0 1em 0 2.5em;
      width: initial;
      max-width: initial;
    }
    ${Toolbar} {
      padding-top: 2.5em;
    }
  }
`;
